import { Button, Col, Row } from "antd";
import Title from "antd/lib/typography/Title";
import * as React from "react";
import { DataGrid } from "@core-ui/datagrid";
import FormLabel from "../../../core/ui/components/FormLabel";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";
import { TOrganisationIndexGroupPresentationModel } from "../../presenter/model/OrganisationIndexGroupPresentationModel";

const IndexGroupData = ({
  translate,
  groupInfoVisible,
  clickedGroup,
  changeUpdateIndexGroupModalVisible,
  findConnectionCandidatesForGroup,
  connectedIndexGroups,
  canEdit,
  checkCanGroupBeRemoved
}: {
  translate;
  groupInfoVisible: boolean;
  clickedGroup: IOrganisationIndexGroup;
  changeUpdateIndexGroupModalVisible: any;
  findConnectionCandidatesForGroup: any;
  connectedIndexGroups?: TOrganisationIndexGroupPresentationModel[];
  canEdit: any;
  checkCanGroupBeRemoved: any;
}) => {
  const columns = [
    {
      title: translate("editors.organisation_index_groups.organisation"),
      key: "organisation",
      dataIndex: ["organisation", "name"]
    },
    {
      title: translate("editors.organisation_index_groups.name"),
      key: "name",
      dataIndex: ["name"]
    }
  ];

  const showConnectedIndexGroups = () => {
    return (
      connectedIndexGroups &&
      connectedIndexGroups?.length > 0 && (
        <div style={{ marginTop: "2em" }}>
          <div
            style={{
              marginBottom: "0.5em"
            }}
          ></div>
          <DataGrid
            tableFormManager={{
              columns: columns,
              dataSource: connectedIndexGroups,
              keyProperty: "id",
              locale: {}
            }}
            headerFormManager={{
              title: translate(
                "editors.organisation_index_groups.connected_index_groups"
              )
            }}
            searchFormManager={{
              searchEnabled: false,
              searchTablePlaceholder: "",
              searchFunction: null
            }}
            pagingFormManager={{
              dataSource: connectedIndexGroups,
              itemsPerPageLabel: "",
              showingLabel: translate(
                "editors.organisation_index_groups.showing_label"
              ),
              totalLabel: translate(
                "editors.organisation_index_groups.total_label"
              ),
              toLabel: translate("editors.organisation_index_groups.to_label"),
              pageSize: 10
            }}
            deleteModalFormManager={{}}
            createModalFormManager={{}}
            updateModalFormManager={{}}
          />
        </div>
      )
    );
  };

  return groupInfoVisible ? (
    <div className="index-details">
      <Row justify="space-between">
        <Col span={16}>
          <Title level={2}>
            {translate("editors.organisation_index_groups.details")}
          </Title>
        </Col>
        {canEdit() && (
          <Col span={8}>
            <Button
              danger
              onClick={() => checkCanGroupBeRemoved(clickedGroup)}
              style={{ float: "right", marginRight: "1em" }}
              type="primary"
            >
              {translate("editors.case_law_documents.remove")}
            </Button>
            <Button
              onClick={() => changeUpdateIndexGroupModalVisible(true)}
              style={{ float: "right", marginRight: "1em" }}
              type="primary"
            >
              {translate("editors.case_law_documents.update")}
            </Button>
          </Col>
        )}
      </Row>
      <FormLabel text={translate("editors.organisation_index_groups.group")} />
      <p>{clickedGroup?.name}</p>
      <div>
        <div>
          <div>
            <FormLabel
              text={translate("editors.organisation_index_groups.type")}
            />
            <p>{clickedGroup?.groupType?.name}</p>
          </div>
          {clickedGroup?.organisationIndexCategory?.name && (
            <div>
              <FormLabel
                text={translate("editors.organisation_index_groups.category")}
              />
              <p>{clickedGroup?.organisationIndexCategory?.name}</p>
            </div>
          )}
          {canEdit() && !clickedGroup?.harmonized && (
            <Button
              onClick={() => findConnectionCandidatesForGroup(clickedGroup)}
              style={{ marginTop: "0.5em" }}
            >
              {translate("editors.organisation_indexes.show_candidates")}
            </Button>
          )}
        </div>
        {showConnectedIndexGroups()}
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default IndexGroupData;
